<template>
    <div id="app" class="config-manager">
        <settings-drawer></settings-drawer>
        <div v-if="isAutomatedTest" style="height: 100%">
            <layout-container c-id="layoutContainer_devdash_automated_testing_portal"></layout-container>
        </div>
        <div v-else style="height: 100%">
            <layout-container c-id="layoutContainer_devDashParent"></layout-container>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";
import { uStore } from "@common/userStore";
import { configStore } from "@common/configStore";

const devDashComponent = {
    data() {
        return {
            editorEnabled: false,
            isAutomatedTest: false,
        };
    },
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue'))
    },
    async mounted() {
        uStore().getUserData().then((user) => {
            this.user = user;
            this.editorEnabled = true;
        });
        // eg: http://localhost/?isAutomatedTest&components={%22componentPreview%22:{%22previewEnabled%22:%22true%22,%20%22componentId%22:%20%22buildInfo_vms_about%22}}#/
        if (window.location.search.indexOf('isAutomatedTest') !== -1) this.isAutomatedTest = true;
    }
};

export default devDashComponent;
</script>

<style lang="css">
@import "~@common/global.css";
@import "~@common/styles/utilities.css";

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
    padding: 0;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    font-size: 16px !important;
    height: 100vh;
}
.menu-panel {
    /*padding: 5px;*/
}
.content-panel {
    padding: 10px;
}

#config-manager-menu .e-acrdn-header {
    border-bottom: 1px solid #eee;
}
#config-manager-menu .e-acrdn-header:hover {
    background: #f6ecf3;
}
#config-manager-menu .e-accordion {
    border: 0 none;
}

.left-menu-item {
    border-bottom: 1px solid #000066;
}

.left-menu-item .left-menu-header {
    font-weight: bold;
    padding: 8px;
    color: #e0e0e0;
    background: #373737;
}

.left-menu-sub-content {
    padding: 0 10px;
}

.pane-container {
    flex-grow: 9;
}

.default-preview-link {
    background: rgb(227, 22, 91);
    color: #fff;
    display: block;
    padding: 6px 10px;
    border: 0 none;
    cursor: pointer;
}

/* For split button */
.e-btn.preview-link {
    background-color: rgb(222, 214, 214);
    color: #3d3d3d;
    height: 100%;
    padding: 0 2px 0 2px;
    border: 0 none;
    border-left: 2px solid white;
    border-radius: 0;
}
.e-btn.preview-link.e-popup-open {
    height: auto;
}
.selected-item .e-btn.preview-link {
    background-color: rgb(224, 183, 183);
    color: #212121;
}
.preview-link.e-btn .e-btn-icon.e-icon-right, .e-css.e-btn .e-btn-icon.e-icon-right {
    margin-right: 0;
}
.preview-link:hover, .preview-link .e-btn:hover,
.preview-link .e-css.e-btn:hover {
    background: rgb(227, 22, 91);
    border-left: 2px solid white;
    color: #fff;
}

.preview-link.e-dropdown-popup {
    background: #fff;
    color: #222;
}

.default-list-item {
    display: flex;
}

.default-list-item-name {
    padding: 5px;
    background-color: #eee;
    border-bottom: 1px solid white;
    font-weight: bold;
    cursor: pointer;
    flex-grow: 9;
}

.e-icons.e-search:before {
    content: '\e993' !important;
}

.e-icons.e-cog:before {
    content: '\e679' !important;
}

.e-icons.e-delete:before {
    content: '\e84e' !important;
}

.component-preview-settins,
.dataset-preview-settins {
    height: 100%;
}

#previewTitle {
    font-size: 15px;
    font-weight: bold;
}
.fl {
    float: left;
}

.e-btn {
    margin-top: 0 !important;
}

.e-control label {
    font-size: 15px;
}

.p0 {
    padding: 0px !important;
}
.control {
    padding-top: 0;
    padding-bottom: 0;
}

.clearfix {
    clear: both;
}

.header-content div[class^='col-'] {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
}

#main-splitter.e-control,
.e-control.e-accordion {
    margin-top: 0px;
}

#preview-splitter {
    margin-top: 0;
}

.header-content h3 {
    width: 25%;
}

.header-content #previewButtons {
    width: 75%;
}

#previewUseLive {
    padding-top: 6px;
}

#main-splitter {
    border: none;
}

#headerRightMessage {
    position: relative; float: right;
}
#buildInfo {
    padding: 10px;
    text-align: right;
}
[cid="buttonPanel_devDashLogout"] {
    margin: 6px 0 0 auto;
}
</style>
<style scoped>

:deep([cid="controlPanel_devDash"]) {
  padding-left: 15px;
}
:deep(.switch-between-instance-and-localhost) {
    position: absolute;
    right: 25px;
    top: 55px;
}
</style>
